import { DealDisqualificationRuleAPI } from '@business/api/deal';
import { DealDisqualificationRuleId, DealDisqualificationRuleRequest, DealDisqualificationRuleResponse } from '@business/entities/deal';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { tap } from 'rxjs/operators';

export class DealDisqualificationRuleBloc extends BaseBloc {
  private readonly repo = new Repository<DealDisqualificationRuleResponse>({
    getItemId: item => item.id,
  });

  items$ = this.repo.items$;

  readonly selectItem = this.repo.selectItem;

  onReset() {
    this.repo.reset();
  }

  fetchRules = () => {
    return DealDisqualificationRuleAPI.fetchRules().pipe(
      tap(items => {
        this.repo.reset();
        this.repo.addMany(items);
      }),
      handleMessage({ error: requestMessage('fetch_disqualification_rules_error') }),
    );
  };

  createRule = (data: DealDisqualificationRuleRequest) => {
    return DealDisqualificationRuleAPI.createRule(data).pipe(
      this.repo.ops.addOne(item => item),
      handleMessage({ type: requestMessage('create_disqualification_rule') }),
    );
  };

  deleteRule = (id: DealDisqualificationRuleId) => {
    return DealDisqualificationRuleAPI.deleteRule(id).pipe(
      this.repo.ops.removeOne(() => id),
      handleMessage({ type: requestMessage('delete_disqualification_rule') }),
    );
  };
}
